import _ from 'lodash';
import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import PageTemplateActions from './page-template-actions';

const initialState = Immutable({
  byId: {},

  isFetching: false,

  isSaving: false,
  isSaveSuccess: false,
  isSaveError: false,
});

const reducer = createReducer(on => {
  on(PageTemplateActions.fetchPageTemplates, state => {
    return state.set('isFetching', true);
  });
  on(PageTemplateActions.fetchPageTemplatesFailure, state => {
    return state.set('isFetching', false);
  });

  on(PageTemplateActions.fetchPageTemplatesSuccess, (state, { pageTemplates }) => {
    const byId = _.reduce(
      pageTemplates,
      (acc, pageTemplate) => {
        acc[pageTemplate.id] = pageTemplate;
        return acc;
      },
      {}
    );
    return state.merge({ isFetching: false, byId });
  });

  on(PageTemplateActions.resetPageTemplates, state => initialState);
}, initialState);

export default reducer;
